import { createContext } from "react";
const SetSessionTokenContext = createContext(() => {
  throw new Error("SetSessionTokenContext is not set");
});
export {
  SetSessionTokenContext
};
//# sourceMappingURL=SetSessionTokenContext.js.map
